import { Applications } from "redux/constants/Applications";

const initState = {
  data: [],
  loading: false,
};

const applications = (state = initState, action) => {
  switch (action.type) {
    case Applications.LOADING_APPLICATIONS_LIST:
      return {
        ...state,
        loading: action.payload,
      };
    case Applications.GET_APPLICATIONS_LIST:
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
};

export default applications;